import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type TrackSwapQueryVariables = Types.Exact<{
  orderId: Types.Scalars['Int'];
}>;


export type TrackSwapQuery = { __typename?: 'query_root', customer?: Types.Maybe<{ __typename?: 'CustomerMetadata', id: number, firstName?: Types.Maybe<string>, lastName?: Types.Maybe<string>, email?: Types.Maybe<string>, phone?: Types.Maybe<string> }>, order?: Types.Maybe<(
    { __typename?: 'orders' }
    & TrackOrderFragment
  )> };

export type TrackOrderFragment = { __typename?: 'orders', id: number, code: string, orderItems: Array<{ __typename?: 'order_items', id: number, buyingPriceInCents: number, taxAmountInCents?: Types.Maybe<number>, item: { __typename?: 'items', id: number, sku: string, name: string, properties?: Types.Maybe<any>, itemType: string } }> };

export const TrackOrderFragmentDoc = gql`
    fragment TrackOrder on orders {
  id
  code
  orderItems: order_items {
    id
    buyingPriceInCents: buying_price_in_cents_excl_tax
    taxAmountInCents: tax_amount_in_cents
    item {
      id
      sku
      name
      properties
      itemType: item_type
    }
  }
}
    `;
export const TrackSwapDocument = gql`
    query trackSwap($orderId: Int!) {
  customer: nest_getCustomerMetadata {
    id
    firstName
    lastName
    email
    phone
  }
  order: orders_by_pk(id: $orderId) {
    ...TrackOrder
  }
}
    ${TrackOrderFragmentDoc}`;
export function useTrackSwapQuery(baseOptions: Apollo.QueryHookOptions<TrackSwapQuery, TrackSwapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackSwapQuery, TrackSwapQueryVariables>(TrackSwapDocument, options);
      }
export function useTrackSwapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackSwapQuery, TrackSwapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackSwapQuery, TrackSwapQueryVariables>(TrackSwapDocument, options);
        }
export type TrackSwapQueryHookResult = ReturnType<typeof useTrackSwapQuery>;
export type TrackSwapLazyQueryHookResult = ReturnType<typeof useTrackSwapLazyQuery>;
export type TrackSwapQueryResult = Apollo.QueryResult<TrackSwapQuery, TrackSwapQueryVariables>;